var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkdin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10229_4498)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 11,
    r: 8.75,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11C5.5 6.85786 8.85786 3.5 13 3.5C17.1421 3.5 20.5 6.85786 20.5 11C20.5 15.1421 17.1421 18.5 13 18.5C8.85786 18.5 5.5 15.1421 5.5 11Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8652 8.0473C10.8651 8.27107 10.7761 8.48564 10.6178 8.64379C10.4595 8.80195 10.2448 8.89074 10.0211 8.89063C9.79729 8.89051 9.58272 8.80151 9.42456 8.6432C9.26641 8.48489 9.17762 8.27023 9.17773 8.04645C9.17785 7.82268 9.26685 7.60811 9.42516 7.44996C9.58347 7.2918 9.79813 7.20301 10.0219 7.20313C10.2457 7.20324 10.4602 7.29224 10.6184 7.45055C10.7766 7.60886 10.8653 7.82352 10.8652 8.0473ZM10.8905 9.51542H9.20305V14.7973H10.8905V9.51542ZM13.5568 9.51542H11.8777V14.7973H13.5399V12.0256C13.5399 10.4815 15.5523 10.3381 15.5523 12.0256V14.7973H17.2187V11.4518C17.2187 8.84886 14.2402 8.94589 13.5399 10.2242L13.5568 9.51542Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10229_4498",
    x: -1,
    y: -1,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.105882 0 0 0 0 0.109804 0 0 0 0 0.113725 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10229_4498"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10229_4498",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin);
export default __webpack_public_path__ + "static/media/linkdin.6ebb64be0583412d93b54cd24b46b9e3.svg";
export { ForwardRef as ReactComponent };